// ** React Imports

// ** Next Imports
import { useRouter } from 'next/router'

// ** MUI Imports
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'

// ** Icon Imports
import ReportProblemRoundedIcon from '@mui/icons-material/ReportProblemRounded'

// import DoubleArrowRoundedIcon from '@mui/icons-material/DoubleArrowRounded'

// ** Hook Imports
import useFetch from 'src/hooks/useFetch'
import useSWR from 'swr'

// ** Configs
import endPoint from 'src/configs/endpoints/rekrutmenEndPoints'

// ** Custom Components Imports

// ** Third Party Imports
// import { format } from 'date-fns'
// import { id as IND } from 'date-fns/locale'

interface TahapanRekrutmen {
  id: string
  rekrutmen_id: string
  judul: string
  tanggal_mulai: string
  tanggal_akhir: string
  status_tahapan_rekrutmen: string
  created_at: string
  updated_at: string
}

interface ResponseTahapanRekrutmen {
  success: boolean
  message: string
  data: TahapanRekrutmen[]
}

const TahapanRekrutmen = () => {
  const router = useRouter()

  const { id } = router.query

  const { FetchWithPayload } = useFetch()

  const payload = {
    url: `${endPoint.rekrutmenTahapanEndpoint}/${id}`,
    method: 'GET'
  }

  const { data, isLoading } = useSWR<ResponseTahapanRekrutmen>(
    id ? [`${process.env.NEXT_PUBLIC_BASE_PATH}/api/reqHandler/`, payload] : null,
    FetchWithPayload
  )

  return !isLoading && data && data.data ? (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Typography
        variant='body1'
        sx={{ fontWeight: 700, color: theme => theme.myColor?.colorToggle, fontSize: '1.5rem' }}
      >
        Tahapan Rekrutmen
      </Typography>
      {data.data.length == 0 ? (
        <Box
          sx={{
            p: 4,
            height: 100,
            borderRadius: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: theme => theme.palette.error.light
          }}
        >
          <ReportProblemRoundedIcon color='error' sx={{ mb: 2 }} />
          <Typography variant='body1' sx={{ fontWeight: 600, textAlign: 'center' }}>
            Silahkan tambahkan Tahapan rekrutmen!
          </Typography>
        </Box>
      ) : null}
      {data.data.map((ele, index) => (
        <Box key={ele.id} sx={{ display: 'flex', mb: 1, alignItems: 'center' }}>
          <Typography
            sx={{
              mr: 2,
              fontWeight: 700,
              fontSize: '1.2rem',
              lineHeight: 1,
              width: '30px',
              textAlign: 'left',
              color: theme => theme.myColor?.colorToggle
            }}
          >
            {`0${index + 1}`}
          </Typography>
          <Box>
            <Typography variant='body1' fontWeight={500} sx={{ fontSize: '1rem' }}>
              {ele.judul}
            </Typography>
            {/* <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Box sx={{ width: 120 }}>
                <Box
                  sx={{
                    px: 2,
                    fontSize: '0.6rem',
                    borderRadius: 4,
                    border: theme => `1px solid ${theme.palette.info.main}`,
                    backgroundColor: theme => theme.palette.info.light,
                    width: 'fit-content'
                  }}
                >
                  {format(new Date(ele.tanggal_mulai), 'dd MMMM yyyy', { locale: IND })}
                </Box>
              </Box>
              <DoubleArrowRoundedIcon fontSize='small' sx={{ mr: 1 }} />
              <Box
                sx={{
                  px: 2,
                  fontSize: '0.6rem',
                  borderRadius: 4,
                  border: theme => `1px solid ${theme.palette.warning.main}`,
                  backgroundColor: theme => theme.palette.warning.light,
                  width: 'fit-content'
                }}
              >
                {format(new Date(ele.tanggal_akhir), 'dd MMMM yyyy', { locale: IND })}
              </Box>
            </Box> */}
          </Box>
        </Box>
      ))}
    </Box>
  ) : null
}

export default TahapanRekrutmen
